import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { MdClose } from "react-icons/md";
import { BsArrowDown } from "react-icons/bs";
import * as Yup from "yup";
import Spinner from "react-bootstrap/esm/Spinner";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import TablePagination from "../../../../components/UI/Table/TablePagination";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import funcionalidades from "../../../../context/AuthContext.funcionalidades";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import HtmlToString from "../../../../components/Formatters/HtmlToString";

const CarregandoView = (
  <span>
    <Spinner animation="border" role="status" /> Carregando ...
  </span>
);

const removeCell = (row, setShowDesassociarConfirm) => (
  <ButtonImagePermission
    permission={funcionalidades.ordemservico.deletarAltExecutor}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() =>
      setShowDesassociarConfirm({
        show: true,
        body: `Deseja remover o executor ${row.nomeFormal}?`,
        context: row.codigoExecutor,
        status: row.status,
      })
    }
    buttonImage={<MdClose />}
    tooltipImage="Remover Auditor"
  />
);

const columns = [
  {
    name: "Setor",
    selector: (row) => row.siglaOrgao,
    center: true,
    sortable: true,
  },
  {
    name: "Nome",
    selector: (row) => row.nomeFormal,
    width: "30%",
    sortable: true,
  },
  {
    name: "Matrícula",
    selector: (row) => row.matricula,
    center: true,
  },
  {
    name: "Qtd Ações",
    selector: (row) => row.quantidadeOs,
    width: "12%",
    center: true,
    sortable: true,
  },
  {
    name: "Tipos de Ação Fiscal",
    cell: (row) =>
      row.quantidadeTipoAf ? (
        <span>
          <HtmlToString html={row.quantidadeTipoAf} />
        </span>
      ) : (
        ""
      ),
    width: "33%",
    center: true,
  },
];

const validationSchema = Yup.object().shape({
  sequencialOrgao: Yup.string().default(""),
  nomeFormal: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ListaExecutoresAssociadosExclusao = ({
  sqAltExec,
  associadoExcluido,
  quantidadeExcluidosOs,
  fgLimpar,
  fgLimparOs,
}) => {
  const [executoresSalvosExclusao, setExecutoresSalvosExclusao] = useState([]);
  const [sqAlteracaoExecutor, setSqAlteracaoExecutor] = useState(0);
  const [codExecutorExcluido, setCodExecutorExcluido] = useState("");
  const [codExecutorNaoExcluido, setCodExecutorNaoExcluido] = useState("");

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showDesassociarConfirm, setShowDesassociarConfirm] = useState({
    show: false,
    body: null,
    context: null,
    status: null,
  });

  const {
    request: requestAssociadosExclusao,
    data: dataAssociadosExclusao,
    isLoading: isLoadingAssociadosExclusao,
  } = useApiClient();

  useEffect(() => {
    if (sqAltExec !== 0) {
      setSqAlteracaoExecutor(sqAltExec);
    } else if (fgLimpar) {
      setSqAlteracaoExecutor(0);
    }
  }, [fgLimpar, sqAltExec]);

  useEffect(() => {
    if (associadoExcluido !== "") {
      setCodExecutorExcluido(associadoExcluido);
    }
  }, [associadoExcluido]);

  useEffect(() => {
    if (sqAlteracaoExecutor !== 0 || codExecutorExcluido !== "" || codExecutorNaoExcluido !== "" || fgLimpar) {
      requestAssociadosExclusao(apiRoutes.fiscalizacao.alteracaoexecutor.consultaExecutorAltExcExclusao, {
        sqAlteracaoExecutor,
      });
    }
  }, [codExecutorNaoExcluido, codExecutorExcluido, requestAssociadosExclusao, sqAlteracaoExecutor, fgLimpar]);

  useEffect(() => {
    if (dataAssociadosExclusao) {
      setExecutoresSalvosExclusao(dataAssociadosExclusao.result);
      quantidadeExcluidosOs(dataAssociadosExclusao.result.length);
      setCodExecutorExcluido("");
      setCodExecutorNaoExcluido("");
      fgLimparOs(false);
    }
  }, [dataAssociadosExclusao, fgLimparOs, quantidadeExcluidosOs]);

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData && codExecutorNaoExcluido) {
      toast.success("Exclusão de executor salva com sucesso.");
      setCodExecutorNaoExcluido(deleteItemData.result.value);
      setCodExecutorExcluido("");
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
      setCodExecutorExcluido("");
      setCodExecutorNaoExcluido("");
    }

    setShowDesassociarConfirm({ show: false });
  }, [codExecutorNaoExcluido, deleteItemData, deleteItemErrors]);

  const columnsAssociadosExclusao = [
    ...columns,
    {
      name: "Ações",
      selector: "",
      width: "10%",
      center: true,
      cell: (row) => removeCell(row, setShowDesassociarConfirm),
    },
  ];

  return (
    <>
      <EfisModal
        show={showDesassociarConfirm.show}
        body={showDesassociarConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowDesassociarConfirm({ show: false })}
        confirmationHandler={() => {
          setCodExecutorNaoExcluido(showDesassociarConfirm.context);
          const params = {
            sequencialAlteracaoExecutor: sqAlteracaoExecutor,
            codigoExecutor: showDesassociarConfirm.context,
            status: showDesassociarConfirm.status,
          };
          deleteItemRequest(apiRoutes.fiscalizacao.alteracaoexecutor.excluirAltExecOs, params);
        }}
      />

      {executoresSalvosExclusao.length > 0 && (
        <>
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow mb-4">
                <div className="card-header pt-3 pb-0 flex-row w-100">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1 py-3">
                    Executores salvos para exclusão{" "}
                  </h6>
                </div>

                <div className="card-body">
                  <DataTable
                    noHeader
                    title="Executores salvos para exclusão"
                    keyField="id"
                    columns={columnsAssociadosExclusao}
                    data={executoresSalvosExclusao}
                    progressPending={isLoadingAssociadosExclusao}
                    noDataComponent="Nenhum registro para exibir"
                    progressComponent={CarregandoView}
                    defaultSortFieldId={1}
                    sortIcon={<BsArrowDown />}
                    pagination
                    sortable
                    pointerOnHover
                    paginationComponent={TablePagination}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      )}
    </>
  );
};

export default ListaExecutoresAssociadosExclusao;
